import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import {
  Details,
  Body,
  Copy,
  StandardPrice,
} from '../../Shared/PricingCard/styles';

export const TutoringCardBody = styled(Body)`
  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    padding: 10px 20px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xl')}) {
    padding: 10px 40px;
  }
`;

export const TutoringCardDetails = styled(Details)`
  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    margin: 0;
    padding-top: 0;
  }
`;

export const TutoringCopy = styled(Copy)`
  margin: 0 0 5px;
`;

export const CurrencySymbol = styled.sup`
  font-size: 40px;
`;

export const TutoringStandardPrice = styled(StandardPrice)`
  font-size: 24px;
  color: #95a1ad;
`;
